module.exports = __webpack_public_path__ + "img/icon-light-tag-blue.e3204c09.svg";